import { useLang } from '@/i18n';
import EfCardsB from '@elem/ui/ef-cards-b';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EmailCom from '../../common/EmailCom';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724136009020/sectionD_card_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139334544/sectionD_card_1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724136009176/sectionD_card_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139334375/sectionD_card_2_h5.jpg',
            title: t('section_D_card2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724136010220/sectionD_card_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139333792/sectionD_card_3_h5.jpg',
            title: t('section_D_card3_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724136009819/sectionD_card_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139333965/sectionD_card_4_h5.jpg',
            title: t('section_D_card4_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724136074814/sectionD_card_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724139334148/sectionD_card_5_h5.jpg',
            title: t('section_D_card5_title'),
        },
    ];
    return (
        <div className={styles.TheComp} id="ID-SectionD">
            <EfSpec />
            <EfSection title={t('section_D_title')} desc={t('section_D_desc')} />
            <p className="sectionD-tip">{t('section_D_tip')}</p>
            <EfCardsB items={itemsA} />
            <EmailCom
                offTipsL={t('section_win_chance_title')}
                productValue={[4]}
                freeTips={t('section_free')}
                freeTipsR={t('section_bag_4')}
                gtm_event_name="powerkits_submit"
                subscribeData={{
                    sector_name: t('section_D_title'),
                    entry_position: 7,
                }}
            />
        </div>
    );
}
